const state = {
    user: null,
    token: null
}
export default state;